/**
 * Random Avatar niche samples - élethű 6-válaszos kitöltések
 * a Random Teszt Generálás funkcióhoz.
 */
export const AVATAR_RANDOM_SAMPLES = [
  {
    niche: "High-ticket coachok prémium ügyfélszerzése",
    values: {
      audience_offer:
        "Szoló business coachoknak adok 90 napos mentorprogramot, amiben felépítünk egy prémium webinar funnelt és egy letisztult $3-10k ajánlatot.",
      problem:
        "Ott ragadnak heti 20+ 1:1 hívásban, az összes bevétel tőlük függ, és nem tudnak árat emelni anélkül, hogy elveszítenék az ügyfeleket.",
      blocker_and_attempts:
        "Instagramon napi tartalmat gyártanak, olcsó FB hirdetésekkel próbálkoznak, DM-eznek - tömeg jön, de senki nem vesz prémium árat.",
      desired_result:
        "Havi stabil $30k+ bevétel, heti 3 munkanap, minősített beszélgetések jöjjenek magától, autoritás a niche-ben.",
      person_details:
        "38-45 éves, többnyire nő, Budapesten vagy külföldön él, 5-10 éve coach, van egy szolid ügyfélkör de kiégéshez közel áll.",
      how_you_help:
        "A 3R módszerrel (Reposition → Rebuild → Reactivate) átalakítjuk az ajánlatot, felépítünk egy heti webinar rendszert és egy scripted sales folyamatot.",
    },
  },
  {
    niche: "Inzulinrezisztens nők fogyása",
    values: {
      audience_offer:
        "Inzulinrezisztenciával küzdő 35+ nőknek adok 12 hetes online életmód-mentorprogramot, ami alapos lab + étrend + mozgás protokollal dolgozik.",
      problem:
        "Évek óta diétáznak, de a hasukról nem megy le semmi, állandó fáradtság, édesség-utózás, és úgy érzik a saját testük ellenük dolgozik.",
      blocker_and_attempts:
        "Kipróbálták a kalóriaszámolást, keto-t, 16:8-at, edzőtermet - pár kiló lemegy, aztán visszajön. Nem értik, miért nem működik náluk, ami másoknak igen.",
      desired_result:
        "Visszakapni a ruháik méretét, reggel frissen ébredni, energiát érezni a családhoz és a munkához, soha többé ne kelljen diétázni.",
      person_details:
        "38-48 éves nő, Budapest vagy vidéki nagyváros, középvezető, anya, 2 gyerek, időhiányban szenved.",
      how_you_help:
        "Labor-alapú egyéni protokollt építünk, heti videó-update + zárt WhatsApp csoport + receptvault - nem diétát adunk, hanem egy új mindennapi rendszert.",
    },
  },
  {
    niche: "Megfelelési kényszeres nők határhúzása",
    values: {
      audience_offer:
        "Karrierben sikeres, de kapcsolataikban kimerült 35+ nőknek adok 8 hetes 1:1 coaching programot a self-worth és határhúzás témájában.",
      problem:
        "Állandóan igent mondanak, mások érzéseiért felelősnek érzik magukat, és a végén dühösek, fáradtak, de nem tudnak nemet mondani.",
      blocker_and_attempts:
        "Olvasnak önfejlesztő könyveket, hallgatnak podcastot, megpróbáltak asszertívnak lenni - de az első konfliktusnál visszatérnek a régi mintákhoz.",
      desired_result:
        "Tudjanak nemet mondani bűntudat nélkül, hiteles kapcsolatok, saját igényeik legyenek elsők, és belső nyugalom.",
      person_details:
        "35-45 éves nő, vezetői pozíció, anya vagy partnerkapcsolatban, felületesen 'mindenki' csodálja, de belül kiégett.",
      how_you_help:
        "Terápiás eszközökkel + practical határhúzás gyakorlatokkal megyünk lépésenként, 1:1 heti + napi mini audio-visszajelzések, és egy mentori közösség.",
    },
  },
  {
    niche: "Tanácsadók webinarból ügyfélszerzése",
    values: {
      audience_offer:
        "B2B consultantoknak adok 60 napos webinar funnel build-out szolgáltatást, amiben felépítjük a teljes rendszert a hirdetéstől a hívásig.",
      problem:
        "LinkedIn-en és hálózatból szereznek ügyfelet, de ez nem skálázható, nincs előrejelezhetőség, hónapról hónapra ingadozik a pipeline.",
      blocker_and_attempts:
        "Próbáltak cold emailt, LinkedIn outreach-et, content marketinget - drága volt, időigényes, és a leadek minősége alacsony.",
      desired_result:
        "Heti 5-10 minősített discovery hívás a naptárban, előrejelezhető havi ügyfél-inflow, skálázható rendszer ami nélkülük is megy.",
      person_details:
        "40-55 éves férfi, budapesti/európai B2B consultant, 10+ év tapasztalat, cégforma vagy szoló, árbevétel €150-500k.",
      how_you_help:
        "Webinar script + landing + hirdetéskezelés + CRM setup + sales script - kulcsra kész rendszer, amit átadunk és tanítunk használni.",
    },
  },
  {
    niche: "30+ szinglik tudatos párválasztása",
    values: {
      audience_offer:
        "30+ szingli nőknek adok 6 hónapos Conscious Dating programot, ami összeköti a self-work-öt a gyakorlati randi-stratégiával.",
      problem:
        "Éveik óta ugyanazokat a férfiakat vonzzák be - elérhetetlen, érzelmileg távoli, vagy passzív - és lassan feladják a reményt.",
      blocker_and_attempts:
        "Tinderen, Hinge-en dátiznak, olvasnak Attachment elméletet, járnak egyedülállók partijára - de a minta ismétlődik, vagy egyáltalán nincs találkozó.",
      desired_result:
        "Egy egészséges, reciprok, komoly kapcsolat egy emocionálisan elérhető férfival - család lehetősége benne, nyugodt magabiztosság a randizás körül.",
      person_details:
        "32-42 éves nő, Budapest vagy külföldön él, magas végzettségű, karrierben sikeres, gyakran 'túl sokat' adott előző kapcsolatokban.",
      how_you_help:
        "Felépítjük az 'emotional availability' filter rendszerét, megtanítjuk a vörös zászlókat és a self-regulation eszközöket, és gyakorlati Dating Playbook-ot adunk.",
    },
  },
  {
    niche: "Vállalkozók kiszervezés és rendszerépítés",
    values: {
      audience_offer:
        "Szoló vállalkozóknak és ügynökségi tulajdonosoknak adok 90 napos SystemsOS mentorprogramot, amiben kiszervezzük a kulcs-műveleteket és felépítünk egy SOP vaultot.",
      problem:
        "Mindent ők csináltak eddig, most a cég növekszik, de ők a szűk keresztmetszet - nem tudnak delegálni, mert nincs dokumentálva semmi.",
      blocker_and_attempts:
        "Próbáltak asszisztenst felvenni, Notion-t használni, template-eket vásárolni - de vagy elakadtak, vagy az asszisztens 'hülyébb' volt mint gondolták.",
      desired_result:
        "Heti 30 óra felszabadított idő, egy megbízható csapat, aki nélkülük is viszi a napi működést, és a tulajdonos stratégiai munkára tud fókuszálni.",
      person_details:
        "35-50 éves férfi vagy nő, saját cég 5-20 fős, árbevétel 100-500M HUF, kiégéshez közel, családi élet háttérbe szorult.",
      how_you_help:
        "A Founder's Freedom framework-kel feltérképezzük a munkát, dokumentáljuk SOP-ba, felveszünk/betanítunk asszisztenst - 90 nap alatt átadjuk a napi ops 70%-át.",
    },
  },
  {
    niche: "Életközépválságos férfiak karrierváltása",
    values: {
      audience_offer:
        "40-55 éves vezető pozíciójú férfiaknak adok 6 hónapos karrier-reset mentorprogramot, ami feltárja a valós hívást és kidolgoz egy exit stratégiát.",
      problem:
        "Sikeresek kívülről - jó fizetés, cím, család - de belül üresnek, csapdába zártnak érzik magukat, és nem tudják, mi az ami valódi öröm lenne.",
      blocker_and_attempts:
        "Olvastak Ikigai könyvet, voltak executive coach-nál, jártak retreat-eken - rövid ideig feldobódtak, aztán visszatértek a régi életükbe.",
      desired_result:
        "Egy tiszta irány ami ÉS energiát ad ÉS pénzt hoz ÉS maradéktalan családi életet enged - a kiszámítható fizetés biztonságával vagy saját vállalkozás formájában.",
      person_details:
        "42-52 éves férfi, multinacionális vezető vagy felsőközépvezető, Budapest/Bécs, 2 gyerek, házas, anyagi biztonság megvan.",
      how_you_help:
        "Egy strukturált Archetype + Strengths + Market-fit process-szel dolgozunk, havi 1:1 + heti async review, 6 hónap végére egy konkrét 'next chapter' tervvel.",
    },
  },
  {
    niche: "Online tanfolyam készítők értékesítése",
    values: {
      audience_offer:
        "Course creator-öknek adok 60 napos Launch Accelerator programot, amiben felépítjük a teljes 7-számjegyű launch gépezetet - emailek, oldal, webinar, hirdetés.",
      problem:
        "Van kész kurzusuk, van 5-20k fős e-mail listájuk, de minden launch után csalódnak: 1-3% konverzió, kevés bevétel, utána kimerülés.",
      blocker_and_attempts:
        "Különböző launch template-eket vásároltak, voltak copywriter-nél, próbáltak ChatGPT-vel emailt írni - de a számok nem javultak lényegesen.",
      desired_result:
        "Egy launch ami 6-7 számjegyű bevételt hoz, dokumentált és ismételhető, stressz nélkül, és nem csak egyszeri 'szerencse'.",
      person_details:
        "32-45 éves nő, saját personal brand, 30-100k followers, már évek óta creatorosok, árbevétel 20-80M HUF/év.",
      how_you_help:
        "A 7-Figure Launch OS blueprint alapján együtt írjuk újra az email sorozatot, optimalizáljuk a webinart, felállítjuk a retargeting rendszert - és lerunoljuk élesben.",
    },
  },
  {
    niche: "Leendő apák önismereti felkészülése",
    values: {
      audience_offer:
        "Első gyereket váró 30-40 éves férfiaknak adok 8 hetes 'Ready for Fatherhood' 1:1 coaching programot, ami feltárja a saját apa-mintát és új identitást épít.",
      problem:
        "Kívülről boldognak tűnnek, de titokban rettegnek a felelősségtől, félnek hogy ugyanolyan apák lesznek mint a sajátjuk volt, és nincsenek rendben önmagukkal.",
      blocker_and_attempts:
        "Olvasnak parenting könyvet, hallgatják a feleségük podcastjait, beszélnek barátokkal - de senki nem adott nekik keretet a saját érzéseikhez.",
      desired_result:
        "Érkezésre kész, egyenletes, jelenlévő apa tudjon lenni, erős kapcsolat a feleséggel, tiszta férfi identitás.",
      person_details:
        "30-40 éves férfi, középvezető vagy vállalkozó, Budapest, első gyerek úton, házas, anyagi biztonság megvan.",
      how_you_help:
        "Heti 1:1 beszélgetés + saját apakép feldolgozása + érzelmi eszköztár + 'new father identity' design - érkezésig konkrét új self-image-zsel.",
    },
  },
  {
    niche: "Finom textil kisvállalkozók skálázása",
    values: {
      audience_offer:
        "Saját márkás textil és home decor kisvállalkozóknak adok 90 napos e-commerce Growth programot, ami felépíti a Shopify funnelt, hirdetést és CRM-et.",
      problem:
        "Gyönyörű termékük van, kis hűséges közönségük, de 2-3 milliós havi forgalomból nem tudnak áttörni - minden rajtuk múlik, nincs marketing rendszer.",
      blocker_and_attempts:
        "Van Instagram-juk, néha FB hirdetést indítanak, email lista passzív - minden 'majdnem' megy, de kiszámíthatatlan.",
      desired_result:
        "Stabil havi 10-20M Ft forgalom, automata email flow, hirdetés-ROAS 3x+ felett, egy csapat ami viszi a napi ops-ot.",
      person_details:
        "35-48 éves nő, kreatív alapító, 1-3 alkalmazott, Budapest vagy régió, 3-5 éve megy a brand.",
      how_you_help:
        "Ecommerce funnel audit → megújított email flow (Klaviyo) + Shopify upsell + hirdetéskezelés setup + heti review - 90 nap alatt 2-3x forgalom-emelés.",
    },
  },
];

export function pickRandomAvatarSample() {
  return AVATAR_RANDOM_SAMPLES[Math.floor(Math.random() * AVATAR_RANDOM_SAMPLES.length)];
}
